import owd from 'owd/owd';

export default class Youtube extends owd.Component {
	init() {
        this.$playbtn = this.$element.find('button');
        this.$video = this.$element.find('iframe');
        this.$cover = this.$element.find('figure, [data-youtube-cover]');

        this.bind();
	}

	bind() {
        this.on('click', this.$playbtn, () => {

            this.$playbtn.fadeOut();
            this.$cover.fadeOut();

            let src = this.$video.attr('data-src');
            this.$video.attr('src', src);
        });

        if (window.innerWidth < 768) {
            this.$element.find('iframe').each(function(){
                let src = $(this).attr('data-src').replace('&autoplay=1', '');
                $(this).attr('src', src);
            });
        }

    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('youtube', {
    component: Youtube
});
